import billingModule from '../../billing.module';
import template from './billingModalSelectPlan.component.html';
import style from './billingModalSelectPlan.component.css';

export default billingModule.component('billingModalSelectPlan', {
    template,
    style,
    bindings: {
        close: '&',
        dismiss: '&',
        modalInstance: '<',
        resolve: '<'
    },
    controller(
        $state,
        $stateParams,
        asLoadingMask,
        asNotifier,
        billingOrderService,
        billingSubscriptionService,
        textResources,
        $rootScope,
        billingOverviewEventConstants
    ) {
        var vm = this;

        vm.$onInit = () => {
            vm.isProcessingOrder = false;
        };

        vm.submitOrder = () => {
            vm.isProcessingOrder = true;

            asLoadingMask.show();

            if (vm.resolve.paymentMethod && vm.resolve.paymentMethod.id) {
                vm.paymentMethodId = vm.resolve.paymentMethod.id;
            }

            vm.close();

            billingSubscriptionService.getCurrentSubscription().then(
                currentSubscription => {
                    billingOrderService
                        .submitOrder(
                            currentSubscription,
                            vm.resolve.plan,
                            vm.paymentMethodId
                        )
                        .then(
                            () => {
                                asNotifier.success(
                                    textResources.billingUpgradeSubscriptionSuccess
                                );

                                $rootScope.$broadcast(
                                    billingOverviewEventConstants.upgradeSubscriptionSuccess
                                );

                                $state.transitionTo(
                                    'billing_overview',
                                    $stateParams,
                                    {
                                        reload: true
                                    }
                                );
                            },
                            () => {
                                asNotifier.errorAndTryAgain(
                                    textResources.billingUpgradeSubscriptionFailed
                                );
                            }
                        )
                        .finally(() => {
                            vm.isProcessingOrder = false;

                            asLoadingMask.hide();
                        });
                },
                () => {
                    asNotifier.errorAndTryAgain(
                        textResources.billingGetCurrentSubscriptionFailed
                    );
                }
            );
        };
    }
});



// WEBPACK FOOTER //
// ./modules/billing/components/billing-modal-select-plan/billingModalSelectPlan.component.js